import { useEffect } from "react";
export var useB2bProfile = function (isProfi) {
    useEffect(function () {
        var _a, _b;
        isProfi && ((_b = (_a = window.chat) === null || _a === void 0 ? void 0 : _a.updateOptions) === null || _b === void 0 ? void 0 : _b.call(_a, {
            application: 's7profi'
        }));
    }, [isProfi]);
};
